import { FormArray, FormControl } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export const ADVANCED_SEARCH_SETTINGS_DEFAULTS = {
    MAX_INLINE_CONTROL_LABEL_WIDTH: '10%',
    MIN_INLINE_CONTROL_LABEL_WIDTH: '100px'
};

export interface AdvancedSearchConfig {
    controls: AdvancedSearchControl[];
}

export enum AdvancedSearchControlType {
    text = 1,
    select,
    toggle,
    number,
    currency,
    date,
    customField
}

export interface AdvancedSearchControl {
    id: string;
    control: FormControl;
    type: AdvancedSearchControlType;
    label: string;
    qsName: string;
    apiAttrName: string;
    selectOptions?: SelectOption[];
    subMenu?: AdvancedSearchControl[];
    addMode?: AdvancedSearchAddMode;
    addModeLimit?: number;
    options?: AdvancedSearchOptions;
}

export interface AdvancedSearchOptions {
    minDate?: NgbDateStruct;
    maxDate?: NgbDateStruct;
    regExPattern?: string;
}

export interface SelectOption {
    id: string;
    label: string;
    extra?: any;
}

export enum AdvancedSearchAddMode {
    oneShot = 0,
    infinite,
    finite
}
